(() => {
  'use strict';
  const labels = window.Plumerive.labels;
  const mobile = matchMedia('(max-width:760px)');
  function setMenu(open) {
    const button = document.querySelector('[data-menu-toggle]');
    const nav = document.getElementById('PrimaryNavigation');
    if (!button || !nav) return;
    nav.classList.toggle('menu-open', open);
    button.setAttribute('aria-expanded', String(open));
    button.setAttribute('aria-label', open ? labels.closeMenu : labels.openMenu);
  }
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-menu-toggle]');
    if (toggle) setMenu(toggle.getAttribute('aria-expanded') !== 'true');
    else if (event.target.closest('#PrimaryNavigation a') || !event.target.closest('.site-header')) setMenu(false);
    const announcement = event.target.closest('.announcement button');
    if (announcement) announcement.closest('.announcement').hidden = true;
    const stepper = event.target.closest('[data-quantity-minus],[data-quantity-plus]');
    if (stepper) {
      const input = stepper.parentElement.querySelector('input[name="quantity"]');
      if (!input) return;
      const value = Number(input.value);
      input.value = Math.max(1, (Number.isFinite(value) ? Math.floor(value) : 1) + (stepper.hasAttribute('data-quantity-plus') ? 1 : -1));
      input.dispatchEvent(new Event('change', {bubbles:true}));
    }
  });
  document.addEventListener('keydown', event => {
    const button = document.querySelector('[data-menu-toggle]');
    if (event.key === 'Escape' && button?.getAttribute('aria-expanded') === 'true') { setMenu(false); button.focus(); }
  });
  mobile.addEventListener('change', () => setMenu(false));
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-variant-select]');
    if (select) {
      const option = select.selectedOptions[0];
      const form = select.form;
      const submit = form.querySelector('[data-product-submit]');
      document.querySelector('[data-product-price]').textContent = option.dataset.price;
      submit.disabled = option.dataset.available !== 'true';
      submit.textContent = submit.disabled ? labels.sold : labels.add;
      const url = new URL(location.href); url.searchParams.set('variant', select.value); history.replaceState({}, '', url);
      document.dispatchEvent(new CustomEvent('plumerive:variant', {detail:{imageId:option.dataset.imageId}}));
    }
    if (event.target.matches('[data-sort-select]')) event.target.form.requestSubmit();
  });
  function setupVideo(root = document) {
    const video = root.querySelector('#film');
    const button = root.querySelector('#toggle');
    if (!video || !button || video.dataset.ready) return;
    video.dataset.ready = 'true';
    const reduced = matchMedia('(prefers-reduced-motion:reduce)');
    const update = () => { button.textContent = video.paused ? '▶' : 'Ⅱ'; button.setAttribute('aria-label', video.paused ? labels.play : labels.pause); };
    button.hidden = false;
    button.addEventListener('click', () => { if (video.paused) video.play().catch(update); else video.pause(); });
    video.addEventListener('play', update); video.addEventListener('pause', update);
    if (reduced.matches || navigator.connection?.saveData) video.pause();
    reduced.addEventListener('change', () => { if (reduced.matches) video.pause(); });
    document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); });
    update();
  }
  setupVideo();
  document.addEventListener('shopify:section:load', event => setupVideo(event.target));
  if (matchMedia('(hover:hover) and (prefers-reduced-motion:no-preference)').matches) {
    document.addEventListener('pointerover', event => {
      const image = event.target.closest('.grid-visual')?.querySelector('[data-hover-src]');
      if (!image || image.src) return;
      image.addEventListener('load', () => { image.hidden = false; }, {once:true});
      image.src = image.dataset.hoverSrc;
    });
  }
})();
